export default __webpack_public_path__ + "static/media/Metropolis-ExtraBoldItalic.a634192e.otf";